import React, { useCallback, useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import styles from './style.module.scss'
import Hyperlink from '../HyperLink'
import { useAnalytics } from '../../../common/analytics'
import SvgIcon from '../SvgIcon'

const CategoriesMenu = ({ data }) => {
  const router = useRouter()
  const { track } = useAnalytics()
  const pid = router.query?.pid
  const selectedCategory = pid && typeof pid === 'object' ? pid[0] : ''

  let scrollMenuRef = useRef(null)
  const [scrollX, setScrollX] = useState(0)
  const [scrollEnd, setScrollEnd] = useState(false)

  const slide = useCallback(
    (shift) => {
      scrollMenuRef.current.scrollLeft += shift
      setScrollX(scrollX + shift)

      if (
        Math.floor(
          scrollMenuRef.current.scrollWidth - scrollMenuRef.current.scrollLeft
        ) <= scrollMenuRef.current.offsetWidth
      ) {
        setScrollEnd(true)
      } else {
        setScrollEnd(false)
      }
    },
    [scrollX]
  )

  const scrollCheck = useCallback(() => {
    setScrollX(scrollMenuRef.current.scrollLeft)
    if (
      Math.floor(
        scrollMenuRef.current.scrollWidth - scrollMenuRef.current.scrollLeft
      ) <= scrollMenuRef.current.offsetWidth
    ) {
      setScrollEnd(true)
    } else {
      setScrollEnd(false)
    }
  }, [])

  const onRightClick = useCallback(() => {
    slide(150)
  }, [slide])

  const onLeftClick = useCallback(() => {
    slide(-150)
  }, [slide])

  const handleClick = useCallback(() => {
    const trackData = {
      nav_link_section: 'Blog Menu',
      click_type: 'Submenu Click',
      click_id: 'Submenu',
      click_text: 'FDR-Web | Submenu',
      track_event: 'blog_menu',
    }
    track(trackData)
  }, [track])

  useEffect(() => {
    const element = document.getElementsByClassName(
      'text-gray-510 hover:text-blue-560 border-b border-blue-700'
    )[0]
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }, [selectedCategory])

  return (
    <div className="flex">
      <div
        className={`-ml-1.5 flex rotate-90 cursor-pointer flex-col items-center justify-center pt-2 ${
          scrollX !== 0 ? styles.enableButton : styles.disableButton
        } `}
        onClick={onLeftClick}
      >
        <SvgIcon name="arrowDown" className="w-4" />
      </div>
      <div
        data-testid="categories-menu"
        className={`relative flex scroll-px-16 overflow-x-hidden border-t border-gray-200 ${styles.CategoriesMenuScroll}`}
        id="categories-menu"
        ref={scrollMenuRef}
        onScroll={scrollCheck}
      >
        <div className={`flex flex-row  whitespace-nowrap p-2 md:px-0 lg:px-0`}>
          {data.map(({ title, slug, key }) => (
            <div className="inline-flex items-center" key={`category_${key}`}>
              <Hyperlink
                href={slug ? `/l/${slug}/` : '/blog/'}
                childrenClassNames={`${
                  selectedCategory === slug
                    ? 'border-b border-blue-700 text-gray-510 hover:text-blue-560'
                    : 'text-blue-560 hover:text-blue-700'
                } my-2 mx-3 px-3 text-center text-sm md:mx-2 lg:mx-0 lg:mr-4`}
                onClick={handleClick}
              >
                {title}
              </Hyperlink>
            </div>
          ))}
        </div>
      </div>
      <div
        className={`-mb-3 flex -rotate-90 cursor-pointer flex-col items-center justify-center pl-3 ${
          !scrollEnd ? styles.enableButton : styles.disableButton
        } `}
        onClick={onRightClick}
        data-testid="chat-item"
      >
        <SvgIcon name="arrowDown" className="w-4" />
      </div>
    </div>
  )
}

CategoriesMenu.defaultProps = {
  data: [],
}

CategoriesMenu.propTypes = {
  data: PropTypes.array,
}

export default CategoriesMenu
